import React, { Component } from "react";
import Modal from 'react-bootstrap/Modal';
import Translation from '../../translation/translation.component';
import { Loading } from "../../loading";
import { Button } from "react-bootstrap";
import { TYPE_FUNCTION } from "../../../../constants/external-constants";

class ModalContainer extends Component{
    handelAcceptConfirmation = () => {
        if (typeof this.props.saveDetails === TYPE_FUNCTION) {  
            this.props.saveDetails();
        } 
    }  

    handelsecondaryBtnFc = () => {
        const {secondaryBtnFc} = this.props;
        if(secondaryBtnFc) {
            secondaryBtnFc()
        }
    }

    renderTitle = () => {
        const { title, noTranslation } = this.props;

        if (!title) {
            return "Modal Title";
        }

        if (!noTranslation) {
            return <Translation translationKey={title} />;
        }

        const keywordsToHighlight = ["FAILED", "CANCELLED"];
        const keyword = keywordsToHighlight.find(keyword => title.includes(keyword));
        if (title.includes(keyword)) {
            const parts = title.split(keyword);
            return (
                <span>
                    {parts[0]}
                    <span className="text-danger">{keyword}</span>
                    {parts[1]}
                </span>
            );
        }
        
        return title;
    }

    render(){
        const { dataLoading, children, hideBtn, disabled, isReadAndWrite,buttonName, showSecondarybtn, primaryBtnTooltip, secondaryBtnTooltip, noTranslation } = this.props;
        return(
            <>
            <Modal
                    show={this.props.show}
                    onHide={this.props.handleModal}
                    backdrop="static"
                    keyboard={false}
                    className={`custom-column-modal-container form-modal-container ${this.props.customClass}`}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.renderTitle()}
                        </Modal.Title>
                    </Modal.Header>
                    {
                        dataLoading ?
                            <Loading />
                        :
                        <>
                            <Modal.Body>   
                                {children} 
                            </Modal.Body> 
                            {
                            !hideBtn  &&
                            <Modal.Footer>
                                {isReadAndWrite &&
                                    <>
                                        {
                                            showSecondarybtn &&
                                            <div className={`${secondaryBtnTooltip ? 'btn-tooltiptext' : ''}`}>
                                                    <Button 
                                                        variant="outline-secondary" 
                                                        className="btn-custom-violet-hover-outline" 
                                                        onClick={this.handelsecondaryBtnFc}>Back
                                                    </Button>
                                                    <span className="tooltip-text">{<Translation translationKey={secondaryBtnTooltip}/>}</span>
                                            </div>                                            
                                        }
                                         <div className={`${primaryBtnTooltip ? 'btn-tooltiptext' : ''}`}>
                                            <Button disabled={disabled} className={`default-btn`} 
                                                onClick={() => this.handelAcceptConfirmation()}> 
                                                {buttonName ? buttonName : "Save Changes"}
                                            </Button>
                                            <span className="tooltip-text">{<Translation translationKey={primaryBtnTooltip}/>}</span>
                                         </div>                                       
                                    </>
                                   
                                }
                            </Modal.Footer>  
                            }                        
                        </>
                    }
                    
                </Modal>
            </>
        )
    }
}
export default ModalContainer;